import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SuccessCotizaResponse } from '../models/cotizador.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CotizadorService {
  private readonly endpointCotiza = `${environment.apiCotizador.baseUrl}${environment.apiCotizador.cotiza}`;
  private readonly endpointRecotiza = `${environment.apiCotizador.baseUrl}${environment.apiCotizador.recotiza}`;

  public successCotiza = signal<SuccessCotizaResponse | null>(null);
  public loading = signal<boolean>(false);

  constructor(private http: HttpClient) {}

  cotizar(values: any): void {
    this.loading.set(true);

    const riesgo = values.fuma === 'S' ? `${values.genero}FE` : `${values.genero}NFE`;
    const edadRetiroNum = parseInt(values.edadretiro, 10);

    let ahorro_mensual = 0;
    if (values.ahorro_mensual && (String(values.ahorro_mensual).trim() !== '' || values.ahorro_mensual > 0)) {
      ahorro_mensual = values.ahorro_mensual;
    }

    const peticion: any = {
      datos: {
        ahorroMensual: ahorro_mensual,
        aniosPension: values.anios_pension,
        edadActual: values.edad_actual,
        edadRetiro: edadRetiroNum,
        fuma: values.fuma,
        genero: values.genero,
        ingresoMensual: values.ingreso,
        porcentajeSalario: values.porSueldo
      },
      tarifa: 0,
      riesgo: riesgo
    };

    let url = this.endpointCotiza;

    if (values.recotiza) {
      url = this.endpointRecotiza;
      peticion.nprima = values.ahorro_mensual;
    }

    this.http.post<any>(url, peticion).subscribe({
      next: (response) => {
        this.loading.set(false);
        const resultado = this.procesarRespuesta(response, values);
        this.successCotiza.set(resultado);
      },
      error: () => {
        this.loading.set(false);
        this.successCotiza.set({
          exito: false,
          texto: 'Ocurrió un error al procesar la cotización. Intente más tarde.'
        } as any);
      }
    });
  }

  private procesarRespuesta(res: any, values: any): any {
    if (!res) {
      return { exito: false, texto: 'No se obtuvo respuesta del servidor.' };
    }

    const opcionMedida: any = {};
    let aportaciones: any = {};

    if (values.recotiza) {
      if (res.nprima < values.ahorro_mensual || res.nprima > values.ahorro_mensual) {
        opcionMedida.texto = 'Se ajustó el ahorro mensual debido a que la protección mínima es de $400,000 pesos.';
      }

      opcionMedida.prima = res.nprima;
      opcionMedida.monto = res.mmensual;
      opcionMedida.sumaAsegurada = res.incrementosa;

      res.aportacion = res.aportacion || {};
      res.aportacion.aportacion = values.aportaciones?.porcentaje;
      res.aportacion.aportacionMensual = values.aportaciones?.mensual;

      aportaciones = values.aportaciones;
    } else {
      if (res.aportacion?.aportacion > 100) {
        return {
          exito: false,
          texto: 'Debes ahorrar más de lo que ganas para retirarte a la edad que deseas. Favor de intentar con otra combinación.'
        };
      }

      if (Object.prototype.hasOwnProperty.call(res, 'nprima')) {
        opcionMedida.prima = res.nprima;
        opcionMedida.monto = res.mmensual;
        opcionMedida.sumaAsegurada = res.incrementosa;

        aportaciones.porcentaje = Math.round(res.aportacion.aportacion);
        aportaciones.mensual = Math.round(res.aportacion.aportacionMensual);

        if (res.nprima < values.ahorro_mensual || res.nprima > values.ahorro_mensual) {
          opcionMedida.texto = 'Se ajustó el ahorro mensual debido a que la protección mínima es de $400,000 pesos.';
        }
      } else {
        res.nprima = 0;
        res.incrementosa = 0;
        aportaciones.porcentaje = Math.round(res.aportacion?.aportacion || 0);
        aportaciones.mensual = Math.round(res.aportacion?.aportacionMensual || 0);
      }
    }

    return {
      exito: true,
      data: {
        values: values,
        res: res,
        opcionMedida: opcionMedida,
        aportaciones: aportaciones
      }
    };
  }

  reinicio(): void {
    this.successCotiza.set(null);
    this.loading.set(false);
  }
}